import '../../styles/QuoteStyles/QuoteOverview.css'

import clock from '../../assets/images/icons/nest_clock_farsight_analog_100dp_F8F9FA_FILL0_wght400_GRAD0_opsz48.png';
import lock from '../../assets/images/icons/lock_100dp_F8F9FA_FILL0_wght400_GRAD0_opsz48.png';
import phone from '../../assets/images/icons/call_100dp_F8F9FA_FILL0_wght400_GRAD0_opsz48.png';

const Quote = () => {
    return (
        <header className="km-pageHeader QuoteContainer">
            <div className="km-container quote-header km-enter">
                <div>
                    <p className="km-eyebrow">Request a quote</p>
                    <h1>Get a tailored licensing quote</h1>
                    <p className="km-lead">
                        Tell us what you need and we’ll get back to you with a tailored SAHPRA licensing quote.
                        No account or sign-up needed.
                    </p>
                </div>
                <ul className="quote-points">
                    <li>
                        <img src={clock} alt="" />
                        Response within 1–2 business days
                    </li>
                    <li>
                        <img src={lock} alt="" />
                        Your information is kept confidential
                    </li>
                    <li>
                        <img src={phone} alt="" />
                        Direct consultant support
                    </li>
                </ul>
            </div>
        </header>
    );
};

export default Quote;
